import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import logo from "../Assests/logo.jpeg";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Navbar scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? "bg-white/90 shadow-md backdrop-blur-md" : "bg-transparent"
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <NavLink to='/'>
            <div className="flex items-center gap-2">
              <img
                src={logo}
                alt="logo"
                className="w-[60px] h-[9vh] object-content rounded-full border border-emerald-500 shadow-md"
              />
              <span className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">
                AE Finance
              </span>
            </div>
          </NavLink>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `font-medium ${isActive ? "text-emerald-600" : "text-gray-800 hover:text-emerald-500"
                }`
              }
            >
              Home
            </NavLink>
            <NavLink
              to="/personalloan"
              className={({ isActive }) =>
                `font-medium ${isActive ? "text-emerald-600" : "text-gray-800 hover:text-emerald-500"
                }`
              }
            >
              Personal Loan
            </NavLink>
            <NavLink
              to="/businessloan"
              className={({ isActive }) =>
                `font-medium ${isActive ? "text-emerald-600" : "text-gray-800 hover:text-emerald-500"
                }`
              }
            >
              Business Loan
            </NavLink>
            <NavLink
              to="/creditcard"
              className={({ isActive }) =>
                `font-medium ${isActive ? "text-emerald-600" : "text-gray-800 hover:text-emerald-500"
                }`
              }
            >
              Credit Cards
            </NavLink>
            <NavLink
              to="/aboutus"
              className={({ isActive }) =>
                `font-medium ${isActive ? "text-emerald-600" : "text-gray-800 hover:text-emerald-500"
                }`
              }
            >
              About Us
            </NavLink>

            <NavLink to="/checkout">
              <button className="bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-6 py-2 rounded-full text-sm lg:text-base font-semibold hover:from-emerald-400 hover:to-teal-500 transition-all duration-300 hover:scale-105 hover:shadow-lg shadow-emerald-500/25">
                Apply For Loan
              </button>
            </NavLink>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`${isScrolled ? "text-gray-800" : "text-gray-800"
                } hover:text-emerald-500 transition-colors duration-200`}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div
            className={`md:hidden py-4 border-t bg-white/90 shadow-md backdrop-blur-md 
      ${isScrolled ? "border-emerald-500/30" : "border-emerald-500/30"}`}
          >
            <div className="flex flex-col space-y-4 px-4">
              <NavLink to="/" onClick={() => setIsMenuOpen(false)} className="text-gray-800 hover:text-emerald-500">
                Home
              </NavLink>
              <NavLink to="/personalloan" onClick={() => setIsMenuOpen(false)} className="text-gray-800 hover:text-emerald-500">
                Personal Loan
              </NavLink>
              <NavLink to="/businessloan" onClick={() => setIsMenuOpen(false)} className="text-gray-800 hover:text-emerald-500">
                Business Loan
              </NavLink>
              <NavLink to="/creditcard" onClick={() => setIsMenuOpen(false)} className="text-gray-800 hover:text-emerald-500">
                Credit Cards
              </NavLink>
              <NavLink to="/aboutus" onClick={() => setIsMenuOpen(false)} className="text-gray-800 hover:text-emerald-500">
                About Us
              </NavLink>
              <NavLink to="/checkout" onClick={() => setIsMenuOpen(false)}>
                <button className="bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-6 py-2 rounded-full text-sm font-semibold hover:from-emerald-400 hover:to-teal-500 transition-all duration-300 w-fit">
                  Apply For Loan
                </button>
              </NavLink>
            </div>
          </div>
        )}

      </div>
    </nav>
  );
};

export default Navbar;
